import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { RecentItem, ReduxUserState } from '../types'

export const setRecentItems: CaseReducer<
  ReduxUserState,
  PayloadAction<Array<RecentItem>>
> = (state, action) => {
  state.recentItems = [...action.payload]
}
